import Css from "./style.module.scss";

import coloredLogo from "assets/coloredLogo.svg";

import * as Icons from "@phosphor-icons/react";
import { Button } from "nlib/ui";
import { checkBusinessesFetching, getSelectedBusinessData } from "selectors/businesses";
import { checkIsBusinessUser, getUserData } from "selectors/user";
import { getActiveOrganization, getProjectName } from "selectors/organizations";
import { getTextsData } from "selectors/texts";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BusinessSelector from "nlib/common/BusinessSelector";
import BusinessesActions from "actions/BusinessesActions";
import Countries from "const/Countries";
import LanguageSelector from "nlib/common/LanguageSelector";
import Notifications from "nlib/common/Notifications";
import React, { useCallback, useMemo } from "react";
import SettingsDropDown from "nlib/common/SettingsDropDown";
import ShowIntroButton from "nlib/common/ShowIntroButton";
import UiActions from "actions/UiActions";
import classNames from "classnames";
import useShowCommonModal from "hooks/useShowCommonModal";

const Header = ({ onboarding, hideIntroButton }) => {
  const dispatch = useDispatch();

  const showCommonModal = useShowCommonModal();

  const { businessId } = useParams();

  const activeOrganization = useSelector(getActiveOrganization) || {};

  const { holdUser } = useSelector(getUserData);

  const projectName = useSelector(getProjectName);

  const { uiTexts, messages } = useSelector(getTextsData);

  const businessUser = useSelector(checkIsBusinessUser);

  const businessesFetching = useSelector(checkBusinessesFetching);

  const { settings: { rpaPaused } = {} } = useSelector(getSelectedBusinessData);

  const { superAdminAccess, countryCode, whiteLabel } = activeOrganization || {};

  const handleBusinessSettingClick = useCallback(() => {
    dispatch(UiActions.showEditBusinessSettingsWindow({ businessId }));
  }, [dispatch, businessId]);

  const handleResumeClick = useCallback(async() => {
    const modalResult = await showCommonModal({
      text: messages.resumeAiBookkeeperConfirm,
      headerText: uiTexts.confirm,
      confirm: true,
      okButtonText: uiTexts.resume
    });

    if (modalResult) {
      await dispatch(BusinessesActions.editBusinessSettings(businessId, { rpaPaused: false }));
    }
  }, [
    businessId,
    dispatch,
    messages.resumeAiBookkeeperConfirm,
    showCommonModal,
    uiTexts.confirm,
    uiTexts.resume
  ]);

  const logoStyle = useMemo(() => {
    return { backgroundImage: `url(${whiteLabel?.logoUrl || coloredLogo})` };
  }, [whiteLabel?.logoUrl]);

  return (
    <div className={classNames(Css.header, superAdminAccess && Css.superAdminAccess)}>
      {((activeOrganization.billingId && !activeOrganization.subscriptionId) || holdUser || !businessId || onboarding) && (
        <div className={Css.logo} title={projectName} style={logoStyle}>
          <img src={whiteLabel?.logoUrl || coloredLogo} />
        </div>
      )}
      {businessId
        ? (
          <>
            <BusinessSelector className={Css.businessSelector} />
            {!onboarding && !businessUser && (
              <>
                <Button
                  outline
                  icon={Icons.Gear}
                  className={Css.settingsButton}
                  title={uiTexts.settings}
                  onClick={handleBusinessSettingClick}>
                  {uiTexts.settings}
                </Button>
                {rpaPaused && (
                  <Button
                    warning
                    outline
                    icon={Icons.PauseCircle}
                    loading={businessesFetching}
                    className={Css.pausedButton}
                    onClick={handleResumeClick}>
                    {uiTexts.roboticAiIsPaused}
                  </Button>
                )}
              </>
            )}
          </>
        )
        : null}
      <div className={Css.aside}>
        <div className={Css.item}><Notifications /></div>
        <div className={Css.item}><SettingsDropDown /></div>
        <div className={Css.item}><LanguageSelector /></div>
        {!hideIntroButton && businessUser && !whiteLabel && (countryCode !== Countries.CZ) && (
          <div className={Css.item}><ShowIntroButton /></div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Header);
